export default __webpack_public_path__ + "static/media/babymilestoneImg1.265c310c.png";